import { loader } from 'graphql.macro'

export default async function unlinkClientFromWastepay ({ dataLoaders, variables }) {
  const schema = loader('./unlinkClientFromWastepay.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    id: variables.id
  })
  return response.unlinkClientFromWastepay
}
